<template>
  <div class="dashboard__pagination">
    <ul class="dashboard__pagination__list nav">
      <li class="dashboard__pagination__item">
        <button class="dashboard__pagination__link"
                @click.prevent="toPage(currentPage - 1)"
                :disabled="currentPage === 1">
          <svg viewBox="0 0 24 24" width="24" height="24"><use xlink:href="@/assets/v2/img/sprite.svg#chevron__left"></use></svg>
        </button>
      </li>
      <li v-if="currentPage > 2"
          class="dashboard__pagination__item">
        <button class="dashboard__pagination__link"
                @click.prevent="toPage(1)">1</button>
      </li>
      <li v-if="currentPage > 3"
          class="dashboard__pagination__item">
        <button class="dashboard__pagination__link"
                @click.prevent="toPage(getMiddlePage(1, currentPage))">...</button>
      </li>
      <li v-if="currentPage > 1"
          class="dashboard__pagination__item">
        <button class="dashboard__pagination__link"
                @click.prevent="toPage(currentPage - 1)">{{ currentPage - 1 }}</button>
      </li>

      <li class="dashboard__pagination__item">
        <button class="dashboard__pagination__link link__active">{{ currentPage }}</button>
      </li>

      <li v-if="lastPage !== currentPage"
          class="dashboard__pagination__item">
        <button class="dashboard__pagination__link"
           @click.prevent="toPage(currentPage + 1)">{{ currentPage + 1 }}</button>
      </li>
      <li v-if="lastPage - currentPage > 2"
          class="dashboard__pagination__item">
        <button class="dashboard__pagination__link"
                @click.prevent="toPage(getMiddlePage(currentPage, lastPage))">...</button>
      </li>
      <li v-if="lastPage - currentPage > 1"
          class="dashboard__pagination__item">
        <button class="dashboard__pagination__link"
                @click.prevent="toPage(lastPage)">{{ lastPage }}</button>
      </li>
      <li class="dashboard__pagination__item">
        <button class="dashboard__pagination__link"
                @click.prevent="toPage(currentPage + 1)"
                :disabled="currentPage === lastPage">
          <svg viewBox="0 0 24 24" width="24" height="24"><use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use></svg>
        </button>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'Pagination',
  props: ['value', 'limit', 'totalRecords'],
  data() {
    return {
      currentPage: this.value
    }
  },
  computed: {
    fromItem() {
      return this.limit * (this.currentPage - 1) + 1
    },
    toItem() {
      return (this.limit * this.currentPage) < this.totalRecords ? (this.limit * this.currentPage) : this.totalRecords
    },
    lastPage() {
      return Math.ceil(this.totalRecords/this.limit)
    }
  },
  watch: {
    value(val) {
      this.currentPage = val
    }
  },
  methods: {
    toPage(page) {
      this.$emit('change', page);

      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 100);
    },
    getMiddlePage(first, second) {
      return Math.floor((second - first) / 2 + first);
    }
  }
}
</script>